import * as React from "react"
import { graphql, useStaticQuery } from "gatsby"

const useSiteMetadata = () => {
    const data = useStaticQuery(graphql`
    query {
      page: contentfulPage(name: { eq: "General layout" }) {
        title
        translations {
          key
          value {
            value
          }
        }
      }

      commonMetadata: allContentfulSiteMetadata {
        nodes {
          siteName
          siteBaseUrl
          siteTitlePrefix
          analyticsScriptUrl
          themeColor
          socialMediaImage {
            localFile {
              publicURL
            }
          }
          facebookAppId
          googleSiteVerification
          openGraphArticleSection
          openGraphType
          twitterCardType
          twitterHandle
        }
      }
    }
  `)

  return data
}

export default useSiteMetadata